'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _UIGridConstants = require('./UIGridConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function makeBreakPointsType(range) {
  var rangePropType = _react.PropTypes.oneOf(range);
  var screenSizeShapePropType = _react.PropTypes.shape(_UIGridConstants.SCREEN_SIZES.reduce(function (shape, screenSize) {
    shape[screenSize] = rangePropType;
    return shape;
  }, {}));
  return _react.PropTypes.oneOfType([_react.PropTypes.string, // only intended for UIStepIndicator (#1753)
  rangePropType, screenSizeShapePropType]);
}

function breakPointsToClassName(classMap, breakPoints) {
  if (breakPoints == null) return null; // CRM-12024
  if (typeof breakPoints === 'string') {
    return null;
  }
  if (typeof breakPoints === 'number') {
    return classMap.xs[breakPoints];
  }
  return Object.keys(breakPoints).map(function (screenSize) {
    var value = breakPoints[screenSize];
    return '' + classMap[screenSize][value];
  }).join(' ');
}

exports.default = _react2.default.createClass({
  displayName: 'UIGridItem',

  propTypes: {
    children: _react.PropTypes.any,
    offset: makeBreakPointsType(_UIGridConstants.OFFSET_RANGE).isRequired,
    size: makeBreakPointsType(_UIGridConstants.OFFSET_RANGE).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      offset: 0
    };
  },
  getClassName: function getClassName() {
    var _props = this.props,
        className = _props.className,
        offset = _props.offset,
        size = _props.size;

    return (0, _classNames2.default)(className, breakPointsToClassName(_UIGridConstants.OFFSET_CLASSES, offset), breakPointsToClassName(_UIGridConstants.SIZE_CLASSES, size));
  },
  render: function render() {
    var _props2 = this.props,
        __offset = _props2.offset,
        __size = _props2.size,
        rest = _objectWithoutProperties(_props2, ['offset', 'size']);

    return _react2.default.createElement(
      'div',
      _extends({}, rest, { className: this.getClassName() }),
      this.props.children
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/grid/UIGridItem.js
// module id = 332
// module chunks = 3 4